import React from 'react';
import parse from 'html-react-parser';
import Form from '../Form';
import { TInput } from '../../utils/types';
import ButtonContainer from '../ButtonContainer';

export interface ReceiptProps {
  objdata: {[name: string]: string}
  inputData: TInput
  adgangTilFlow?: boolean
  adgangTilKontaktFlow?: boolean
  showReceipt: boolean
  showReceiptFinal: boolean
  consentFromModal: boolean
  showEmailonlyForm: boolean
  showSalaryContent?: boolean
  showSalaryReceipt: boolean
  samtykkeLabel?: string
  velkomstEpiserverId: string
  handleConsentClick: React.MouseEventHandler<HTMLButtonElement>
  handleSubmittedSkip: React.MouseEventHandler<HTMLButtonElement>
  handleFinalClick: React.MouseEventHandler<HTMLButtonElement>
  handleGoToChaptersClick: React.MouseEventHandler<HTMLButtonElement>
  handleMailModalClick: React.MouseEventHandler<HTMLButtonElement>
  handleSalaryContentSkip: React.MouseEventHandler<HTMLButtonElement>
  setInputData: (inputData: TInput) => void
  setFormSubmitted: (submitted: boolean) => void
  setShowSalaryReceipt: (showSalaryReceipt: boolean) => void
  setShowModal: (showModal: boolean) => void
}

const Receipt = ({
	objdata,
	inputData,
	adgangTilFlow,
	adgangTilKontaktFlow,
	showReceipt,
	showReceiptFinal,
	consentFromModal,
	showEmailonlyForm,
	showSalaryContent,
	showSalaryReceipt,
	samtykkeLabel,
	velkomstEpiserverId,
	setInputData,
	setFormSubmitted,
	setShowSalaryReceipt,
	setShowModal,
	handleSalaryContentSkip,
	handleGoToChaptersClick,
	handleMailModalClick
}: ReceiptProps) => {
	if (showReceipt) {
		if (!showEmailonlyForm && showSalaryContent && !showSalaryReceipt) {
			return (
				<div className="content">
					<div className="content-richtext">
						<h1 className="f24">{ objdata['SalaryTitle'] }</h1>
						{ objdata['SalaryText'] && parse(objdata['SalaryText']) }
					</div>
					<Form
						introButtonText={ objdata['SalaryBtnTxt'] }
						inputData={ inputData }
						showEmail={ false }
						showPhn={ false }
						showSalary={ true }
						showDataPolicy={ true }
						showConsent={ false }
						objdata={ objdata }
						persondataLabel={ objdata['PersondataLabel'] }
						samtykkeLabel={ samtykkeLabel }
						velkomstEpiserverId={ velkomstEpiserverId }
						baseInteraktionDialogId={ objdata['BaseInteraktionDialogId'] }
						setInputData={ setInputData }
						setFormSubmitted={ setFormSubmitted }
						setShowSalaryReceipt={ setShowSalaryReceipt }
						setShowModal={ setShowModal }
					/>
					<ButtonContainer center m_small>
						<button className="btn-text" onClick={ handleSalaryContentSkip }>
							{ objdata['SkipButtonText'] }
						</button>
					</ButtonContainer>
				</div>
			);
		}

		if (!consentFromModal && adgangTilFlow) {
			return (
				<div className="content">
					<div className="content-richtext">
						<h1 className="f24">{ objdata['ReceiptTitle'] }</h1>
						{ objdata['ReceiptText'] && parse(objdata['ReceiptText']) }
					</div>
					<ButtonContainer center>
						{ objdata['ReceiptButtonText'] && <button className="btn btn-primary" onClick={ handleGoToChaptersClick }>{ objdata['ReceiptButtonText'] }</button> }
					</ButtonContainer>
					<ButtonContainer center m_small>
						<button className="btn-text" onClick={ handleMailModalClick }>{ objdata['MailButtonText'] }</button>
					</ButtonContainer>
				</div>
			);
		}

		if (!adgangTilFlow) {
			return (
				<div className="content">
					<div className="content-richtext">
						<h1 className="f24">{ objdata['ReceiptIngenAdgangTitle'] }</h1>
						{ objdata['ReceiptIngenAdgangText'] && parse(objdata['ReceiptIngenAdgangText']) }
					</div>
				</div>
			);
		}

		if (!adgangTilKontaktFlow && objdata['ServicetjekType'] === 'Kontaktinformation') {
			return (
				<div className="content">
					<div className="content-richtext">
						<h1 className="f24">{ objdata['ReceiptIngenAdgangTitle'] }</h1>
						{ objdata['ReceiptIngenAdgangText'] && parse(objdata['ReceiptIngenAdgangText']) }
					</div>
				</div>
			);
		}
	}

	if (showReceiptFinal) {
		if (adgangTilFlow) {
			return (
				<div className="content">
					<div className="content-richtext">
						<h1 className="f24">{ objdata['ReceiptTitle'] }</h1>
						{ objdata['ReceiptText'] && parse(objdata['ReceiptText']) }
					</div>
					<ButtonContainer center>
						{ objdata['ReceiptButtonText'] && (
							<button className="btn btn-primary" onClick={ handleGoToChaptersClick }>
								{ objdata['ReceiptButtonText'] }
							</button>
						) }
					</ButtonContainer>
					<ButtonContainer center m_small>
						<button className="btn-text" onClick={ handleMailModalClick }>{ objdata['MailButtonText'] }</button>
					</ButtonContainer>
				</div>
			);
		} else if (!adgangTilFlow) {
			return (
				<div className="content">
					<div className="content-richtext">
						<h1 className="f24">{ objdata['ReceiptIngenAdgangTitle'] }</h1>
						{ objdata['ReceiptIngenAdgangText'] && parse(objdata['ReceiptIngenAdgangText']) }
					</div>
				</div>
			);
		}
	}

	return null;
};

export default Receipt;
